import records from "./recipes.seed.json";
import type { Recipe } from "../types";

export const seedRecipes = records as Recipe[];
